module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step2-pict01-full-a2df2a5d18fbe247857537b43e36c114.jpg";